<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <h6>Order Details</h6>
      <hr />
      <div
        style="display: grid; grid-template-rows: repeat(1, 1fr); grid-template-columns: repeat(9, 1fr); grid-column-gap: 0.75rem;"
      >
        <b-form-group label="Supplier Name" class="mr-2">
          <!-- <b-form-input type="text" disabled v-model="inventoryDetails.companyName"></b-form-input> -->
          {{ inventoryDetails.companyName }}
        </b-form-group>
        <b-form-group label="Purchase Order No">
          <!-- <b-form-input type="text" disabled v-model="inventoryDetails.purchaseOrderId"></b-form-input> -->
          {{ inventoryDetails.purchaseOrderId }}
        </b-form-group>
        <b-form-group label="Purchase Order Date">{{ inventoryDetails.poDate|date }}</b-form-group>
        <b-form-group label="RMA Date" v-if="onRmaInspection">{{ inventoryDetails.rmaDate|date }}</b-form-group>
        <b-form-group label="Sold To">
          <!-- <b-form-input type="text" disabled v-model="inventoryDetails.customerName"></b-form-input> -->
          {{ inventoryDetails.customerName }}
        </b-form-group>
        <b-form-group label="Qty Sold">
          <!--<b-form-input type="number" disabled v-model="inventoryDetails.quantitySold"></b-form-input>-->
          <!-- <b-form-input type="number" disabled v-model="inventoryDetails.quantity"></b-form-input> -->
          {{ inventoryDetails.quantity }}
        </b-form-group>
        <b-form-group label="Sales Rep">
          <!-- <b-form-input type="text" disabled v-model="salesPersonUserFullName"></b-form-input> -->
          {{ inventoryDetails.salesPersonUserFullName }}
        </b-form-group>
        <b-form-group label="Shipping Pay Method">
          <b-form-radio
            type="radio"
            value="FC"
            name="shippingPayMethod"
            inline
            v-model="model.orderDetail_ShippingPayMethod"
          >FC</b-form-radio>
          <b-form-radio
            type="radio"
            value="PP"
            name="shippingPayMethod"
            inline
            v-model="model.orderDetail_ShippingPayMethod"
          >PP</b-form-radio>
        </b-form-group>
        <b-form-group label="Cod">
          <b-form-checkbox type="radio" v-model="common_cod" @change="cod_change">COD</b-form-checkbox>
        </b-form-group>
        <b-form-group label="Amount">
          <b-form-input type="number" :disabled="!common_cod" v-model="model.orderDetail_CODAmount"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="list-group-item mb-2">
      <h6>Product Details</h6>
      <hr />
      <div
        style="display: grid; grid-template-rows: repeat(1, 1fr); grid-template-columns: repeat(9, 1fr); grid-column-gap: 0.75rem;"
      >
        <b-form-group label="Parts were ordered as">{{ inspectionDetails.conditionName }}</b-form-group>
        <b-form-group label="Qty Rec">
          <b-form-input type="number" v-model="model.productDetails_Received"></b-form-input>
        </b-form-group>
        <b-form-group label="Qty Stock">
          <b-form-input type="number" v-model="model.productDetails_Stock"></b-form-input>
        </b-form-group>
        <b-form-group label="Part Number">
          <!-- <b-form-input type="text" disabled v-model="inspectionDetails.partNumber"></b-form-input> -->
          {{ inspectionDetails.partNumber }}
        </b-form-group>
        <b-form-group label="Date Code">
          <!-- <b-form-input type="text" disabled v-model="inventoryDetails.dateCode"></b-form-input> -->
          {{ inspectionDetails.dateCode }}
        </b-form-group>
        <b-form-group label="Country of Origin">{{ inventoryDetails.countryOfOriginName }}</b-form-group>
        <b-form-group label="Lot Code">
          <!-- <b-form-input type="text" disabled v-model="inventoryDetails.lotCode"></b-form-input> -->
          {{ inspectionDetails.lotCode }}
        </b-form-group>
        <b-form-group label="Mfr">{{ inspectionDetails.mfgName }}</b-form-group>
        <b-form-group label="RoHS">{{ inspectionDetails.leadFree }}</b-form-group>
        <b-form-group label="Part Marking">
          <b-form-input type="text" v-model="model.productDetails_Marking"></b-form-input>
        </b-form-group>
        <b-form-group label="Location">
          <b-form-input type="text" v-model="model.productDetails_Location"></b-form-input>
        </b-form-group>
        <b-form-group label="Break Down">
          <b-form-input type="text" v-model="model.productDetails_Breakdown"></b-form-input>
        </b-form-group>
        <b-form-group label="Physical Packaging">
          <b-form-input type="text" v-model="model.leadVerification_PhysicalPackage"></b-form-input>
        </b-form-group>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { date } from '@/shared/filters';
import {FIELDS}  from '../../constants'
export default {
  name: 'common',
  components: {},
  props: {
    inventoryDetails: {
      type: Object,
      default: () => {},
    },
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
    onRmaInspection: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    date,
  },
  data() {
    return {
      fields_list: FIELDS,
      salesPersonUserFullName: this.inspectionDetails.salesPersonUserFullName || this.inventoryDetails.salesPersonUserFullName,
      common_cod: (this.inspectionDetails[FIELDS.ORDER_DETAIL__CODAMOUNT])?true:false,
      model: {
        orderDetail_ShippingPayMethod: this.inspectionDetails[FIELDS.ORDER_DETAIL__SHIPPING_PAY_METHOD] || '',
        // orderDetail_CODAmount: this.inspectionDetails[FIELDS.ORDER_DETAIL__CODAMOUNT] || '',
        orderDetail_CODAmount: this.inventoryDetails.total,
        /*productDetails_Received: this.inspectionDetails[FIELDS.PRODUCT_DETAILS__RECEIVED] || 0,*/
        productDetails_Received: ((this.inspectionDetails[FIELDS.PRODUCT_DETAILS__RECEIVED] !== null && this.inspectionDetails[FIELDS.PRODUCT_DETAILS__RECEIVED] > 0) ? this.inspectionDetails[FIELDS.PRODUCT_DETAILS__RECEIVED] : this.inventoryDetails.qtyReceived),
        productDetails_Stock: this.inspectionDetails[FIELDS.PRODUCT_DETAILS__STOCK] || 0,
        productDetails_Other: this.inspectionDetails[FIELDS.PRODUCT_DETAILS__OTHER] || '',
        productDetails_Marking: this.inspectionDetails[FIELDS.PRODUCT_DETAILS__MARKING] || '',
        productDetails_Location: this.inspectionDetails[FIELDS.PRODUCT_DETAILS__LOCATION] || '',
        productDetails_Breakdown: this.inspectionDetails[FIELDS.PRODUCT_DETAILS__BREAKDOWN] || '',
        leadVerification_PhysicalPackage: (this.inspectionDetails[FIELDS.LEAD_VERIFICATION__PHYSICAL_PACKAGE] !== null) ? this.inspectionDetails[FIELDS.LEAD_VERIFICATION__PHYSICAL_PACKAGE] : this.inventoryDetails.physPkg,
      },
    };
  },
  methods: {
    cod_change(value) {
      this.model.orderDetail_CODAmount = !value ? '' : this.model.orderDetail_CODAmount;
    },
  },
  computed: {
    ...mapGetters('lookup', []),
  },
  mounted() {
    //console.log(this.inventoryDetails)
    //console.log(this.inspectionDetails);
  },
};
</script>

